<template>
  <q-layout view="hhr lpR ffr" style="font-family: 'Font-principal'">
    <TheNavbar />
    <q-page-container class="app-bg">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </q-page-container>
    <TheFooter />
  </q-layout>
</template>
<script type="text/javascript">
var _userway_config = {
  account: "9jDmsm9lYz"
};
</script>
<script type="text/javascript" src="https://cdn.userway.org/widget.js"></script>
<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import TheNavbar from "@/components/global/TheNavbar.vue";
import TheFooter from "@/components/global/TheFooter.vue";
import store from "@/store";

@Component({
  components: {
    TheNavbar,
    TheFooter
  }
})
export default class App extends Vue {
  created() {
    if (this.$store.state.settings.empresas == null)
      this.$axios
        .get("institucions/1", {
          params: {
            filter: {
              fields: ["empresa", "icono_front"]
            }
          }
        })
        .then(response => {
          let config = response.data;
          this.$store.dispatch("saveConfig", config);
        })
        .catch(error => {});
  }
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
